(function () {
    'use strict';

    angular
        .module('invesfleet')
        .factory('reportingService', reportingService);

    reportingService.$inject = ['$http', '$q', 'endPoints', 'authorization'];

    function reportingService($http, $q, endPoints, authorization) {
        var service = {
            showReport: showReport,
            showPredeterminated: showPredeterminated,
            getRelations: getRelations,
            deleteReport: deleteReport,
            getFields: getFields,
            getFilters: getFilters,
            getReports: getReports,
            getById: getById,
            getFavorites: getFavorites,
            testReport: testReport,
            testCloned: testCloned,
            saveCloned: saveCloned,
            saveReport: saveReport,
            getPredeterminatedFilters: getPredeterminatedFilters,
            showFacturasCliente: showFacturasCliente,
            exportReport: exportReport,
            consumoCombustible: consumoCombustible,
            combustibleRespectoTotal: combustibleRespectoTotal, 
            showFichaje: showFichaje, 
            getEmpleados: getEmpleados, 
            exportFichaje: exportFichaje,
            showServicios: showServicios, 
            exportServicios:exportServicios,
            getEmpresas: getEmpresas
        };

        return service;

        function showReport(reportId) {
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.reporting.showReport + '?id=' + reportId,
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                    deferred.resolve(response);
                },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function showPredeterminated(reportId, filters) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.reporting.showPredeterminated,
                data: {
                    Id: reportId,
                    Filters: filters
                }
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                    deferred.resolve(response);
                },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }
        

        function consumoCombustible(fec, flot) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.reporting.consumoCombustible,
                data: {
                    fecha: fec,
                    flotas: flot
                }
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                    deferred.resolve(response);
                },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

         function getEmpresas() {
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.reporting.getEmpresas,
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                    deferred.resolve(response);
                },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function combustibleRespectoTotal(fec, flot) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.reporting.combustibleRespectoTotal,
                data: {
                    fecha: fec,
                    flotas: flot
                }
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                    deferred.resolve(response);
                },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function showFacturasCliente(reportId, filters) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.reporting.showFacturasCliente,
                data: {
                    Id: reportId,
                    Filters: filters
                }
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                    deferred.resolve(response);
                },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function getRelations(id) {
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.reporting.getRelations + '?id=' + id,
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                    deferred.resolve(response);
                },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function exportReport(id, type, filters) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.reporting.exportReport,
                data: {
                    Id: id,
                    Type: type,
                    Filters: filters
                },
                responseType: 'arraybuffer'
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                    deferred.resolve(response);
                },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

         function exportServicios(from, to, type, empresaId) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.reporting.exportServicios,
                data: {
                    from: from,
                    to: to,
                    type: type, 
                    empresaId: empresaId
                },
                responseType: 'arraybuffer'
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                    deferred.resolve(response);
                },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

          function exportFichaje(empleados, from, to, type) {
             var deferred = $q.defer();
             var request = {
                 method: 'POST',
                 url: endPoints.reporting.exportFichaje,
                 data: {
                     Empleado: empleados, 
                     from: from, 
                     to: to, 
                     Type: type
                 },
                 responseType: 'arraybuffer'
             };
             authorization.setBearerHeader($http);
             $http(request).then(function (response) {
                     deferred.resolve(response);
                 },
                 function (response) {
                     deferred.reject(null);
                 });
             return deferred.promise;
         }

        function deleteReport(id) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.reporting.deleteReport,
                data: id
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                    deferred.resolve(response);
                },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function getFields(clone) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.reporting.getFields,
                data: {
                    list: clone,
                }
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                    deferred.resolve(response);
                },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function getFilters(relations, mainTableId) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.reporting.getFilters,
                data: {
                    Relations: relations,
                    Id: mainTableId
                }
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                    deferred.resolve(response);
                },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function getReports() {
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.reporting.getReports,
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                    deferred.resolve(response);
                },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function getById(id) {
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.reporting.getById + '?id=' + id,
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                    deferred.resolve(response);
                },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function getFavorites() {
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.reporting.getFavorites,
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                    deferred.resolve(response);
                },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function testReport(mainTable, relatedTables, fields, filters, orders) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.reporting.testReport,
                data: {
                    Fields: fields,
                    Filters: filters,
                    MainTable: mainTable,
                    RelatedTables: relatedTables,
                    Orders: orders
                }
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                    deferred.resolve(response);
                },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function testCloned(id, fields, filters, orders) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.reporting.testCloned,
                data: {
                    Id: id,
                    Fields: fields,
                    Filters: filters,
                    Orders: orders
                }
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                    deferred.resolve(response);
                },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function saveCloned(id, userId, name, fields, filters, orders, grupoId, favorito, description) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.reporting.saveCloned,
                data: {
                    Id: id,
                    Name: name,
                    UserId: userId,
                    Fields: fields,
                    Filters: filters,
                    Orders: orders,
                    GrupoId: grupoId,
                    Favorito: favorito, 
                    Description: description
                }
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                    deferred.resolve(response);
                },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function saveReport(id, name, fields, userId, mainTable, relatedTables, filters, orders, grupoId, favorito, description) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.reporting.saveReport,
                data: {
                    Id: id,
                    Name: name,
                    Fields: fields,
                    UserId: userId,
                    MainTable: mainTable,
                    RelatedTables: relatedTables,
                    Filters: filters,
                    Orders: orders,
                    GrupoId: grupoId,
                    Favorito: favorito, 
                    Description: description
                }
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                    deferred.resolve(response.data);
                },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function getPredeterminatedFilters(id) {
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.reporting.getPredeterminatedFilters + '?id= ' + id,
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                    deferred.resolve(response);
                },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

        function showFichaje(id, from, to) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.reporting.showFichaje,
                data: {
                    empleado: id, 
                    from: from, 
                    to: to
                }
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                    deferred.resolve(response);
                },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

         function showServicios(from, to, empresaId) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.reporting.showServicios,
                data: {
                    from: from, 
                    to: to, 
                    empresaId: empresaId
                }
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                    deferred.resolve(response);
                },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

         function getEmpleados() {
             var deferred = $q.defer();
             var request = {
                 method: 'GET',
                 url: endPoints.reporting.getEmpleados,
             };
             authorization.setBearerHeader($http);
             $http(request).then(function (response) {
                     deferred.resolve(response);
                 },
                 function (response) {
                     deferred.reject(null);
                 });
             return deferred.promise;
         }
    }

})();